export default "__VITE_ASSET__C54Nf6B0__"